import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleApplyCouponCode } from "../../Utilities/BannerUtils";
import copy from "../../img/Vector (8).svg";
import "./styles/Festive2026.css";

const IMG_DIR = process.env.PUBLIC_URL + "/resources/images/banner_content/";
const FestBannerBg = IMG_DIR + "Fest26_Desk_Bg.svg";
const FestBannerLeft = IMG_DIR + "Fest26_Comp_Left.svg";
const FestBannerRight = IMG_DIR + "Fest26_Comp_Right.svg";

const COUPON_CODE = "FESTIVE26";

const Festive2026 = ({ showClaimNow, setCouponCode }) => {
    const navigate = useNavigate();
    const [copied, setCopied] = useState(false);

    const handleCopyCode = () => {
        navigator.clipboard.writeText(COUPON_CODE).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const handleOnClickButton = () => {
        if (!document.getElementById("ppa-course-coupon-code-input")) {
            navigate("/pricing");
            // Add a small delay for the new page to render before applying the coupon
            setTimeout(() => {
                handleApplyCouponCode({ couponCode: COUPON_CODE, setCouponCode });
            }, 500);
        } else {
            handleApplyCouponCode({ couponCode: COUPON_CODE, setCouponCode });
        }
    };

    return (
        <div
            className="festive2026-banner"
            style={{ "--festive2026-banner-bg": `url(${FestBannerBg})` }}
        >
            <img src={FestBannerLeft} alt="" aria-hidden="true" className="festive2026-banner-left" />
            <img src={FestBannerRight} alt="" aria-hidden="true" className="festive2026-banner-right" />
            <div className="festive2026-banner-content">
                <p className="festive2026-banner-text">
                    Festive Sale: Get Up to <span className="festive2026-banner-highlight">50% OFF</span> on All
                    Courses
                    <span className="festive2026-banner-desktop-sep"> | Apply Code: </span>
                    <span className="festive2026-banner-mobile-sep">. Code: </span>
                    <span className="festive2026-banner-highlight">{COUPON_CODE}</span>
                </p>
                {showClaimNow ? (
                    <button className="festive2026-banner-claim-btn" onClick={handleOnClickButton}>
                        Claim now
                    </button>
                ) : (
                    <button className="festive2026-banner-claim-btn" onClick={handleCopyCode}>
                        {copied ? (
                            "Copied"
                        ) : (
                            <>
                                <img src={copy} alt="copy code icon" className="festive2026-banner-copy-icon" />
                                Copy code
                            </>
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default Festive2026;
